import jQuery from 'jquery';
function disableScroll() {
    document.body.style.overflow = "hidden";
}

function enableScroll() {
    document.body.style.overflow = "visible";
}

(function ($) {
    $(".title-bar.title-container").on(
        "toggled.zf.responsiveToggle",
        function () {
            $(".menu-icon").toggleClass("active");
            if ($(".menu-icon").hasClass("active")) {
                disableScroll();
                if($(".area-details").length) {
                    $(".area-details").hide();
                }
            } else {
                enableScroll();
            }
        }
    );
})(jQuery);